import React from "react";
import { Helmet } from "react-helmet";

function PrivacyPolicy() {
    return (
        <>
            <Helmet>
                <title>Privacy Policy | 3PL Search</title>
            </Helmet>

            <div className="legal-page">
                <div className="container" style={{ maxWidth: "800px", padding: "3rem 1.5rem" }}>
                    <h1 style={{ color: "#132238", fontWeight: 800, marginBottom: "0.5rem" }}>Privacy Policy</h1>
                    <p className="text-muted mb-4" style={{ fontSize: "0.9rem" }}>Last updated: {new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" })}</p>

                    <p>3PL Search ("we", "our", or "us") is committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, and safeguard your data when you use our platform at <strong>search.shipcube.com</strong>.</p>

                    <h3>1. Information We Collect</h3>
                    <p>We collect information you provide directly, including:</p>
                    <ul>
                        <li>Name, email address, phone number, and company details when you register or submit an enquiry</li>
                        <li>Logistics requirements including SKU count, monthly orders, storage type, and fulfillment regions</li>
                        <li>Warehouse listing details submitted by 3PL providers</li>
                    </ul>

                    <h3>2. How We Use Your Information</h3>
                    <p>Your information is used to:</p>
                    <ul>
                        <li>Match buyers with suitable 3PL warehouse providers</li>
                        <li>Enable our CS team to prepare shortlists and coordinate quotes</li>
                        <li>Send service-related communications and updates</li>
                        <li>Improve the quality and relevance of our directory</li>
                    </ul>

                    <h3>3. Data Sharing</h3>
                    <p>We do not sell your personal data. We may share your information with:</p>
                    <ul>
                        <li>3PL providers you have specifically requested a quote from</li>
                        <li>Our internal CS team to facilitate the matching process</li>
                        <li>Service providers who assist us in operating the platform (subject to confidentiality agreements)</li>
                    </ul>

                    <h3>4. Data Retention</h3>
                    <p>We retain personal data for as long as necessary to fulfil the purposes outlined in this policy, or as required by applicable law. You may request deletion of your data at any time by contacting us.</p>

                    <h3>5. Your Rights</h3>
                    <p>Depending on your location, you may have rights to access, correct, delete, or restrict the processing of your personal data. To exercise these rights, please contact us at <a href="mailto:privacy@shipcube.com">privacy@shipcube.com</a>.</p>

                    <h3>6. Cookies</h3>
                    <p>We use essential cookies to maintain your session. For more detail, see our <a href="/cookie-policy">Cookie Policy</a>.</p>

                    <h3>7. Security</h3>
                    <p>We use industry-standard security measures including encrypted connections (HTTPS), hashed passwords, and JWT-based authentication to protect your data.</p>

                    <h3>8. Changes to This Policy</h3>
                    <p>We may update this policy periodically. Material changes will be communicated via the platform or by email. Continued use of the service after changes constitutes acceptance.</p>

                    <h3>9. Contact</h3>
                    <p>For privacy-related enquiries, contact us at <a href="mailto:privacy@shipcube.com">privacy@shipcube.com</a> or via our <a href="/contact">contact page</a>.</p>
                </div>
            </div>
        </>
    );
}

export default PrivacyPolicy;
